{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/template-part",
	"title": "Template Part",
	"category": "theme",
	"description": "Edit the different global regions of your site, like the header, footer, sidebar, or create your own.",
	"textdomain": "default",
	"attributes": {
		"slug": {
			"type": "string"
		},
		"theme": {
			"type": "string"
		},
		"tagName": {
			"type": "string"
		},
		"area": {
			"type": "string"
		}
	},
	"supports": {
		"align": true,
		"html": false,
		"reusable": false,
		"renaming": false,
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-template-part-editor"
}
